let rpcURL;
rpcURL = "https://bsc-dataseed3.defibit.io";
export { rpcURL };